import React from "react";
import { Col, Row } from "react-bootstrap";
import Switch from "react-switch";
import Addons from "../Addons";

const LeagalInfo = ({
  state,
  setState,
  handleExtraChange,
  extraField,
  handleSaveField,
  activeTab,
}) => {
  const handleToggle = (value, name) => {
    setState((pre) => ({ ...pre, [name]: value }));
  };

  return (
    <div>
      <section className="view-data">
        <Row className="main-view-email pt-3">
          <Col md={6} className="left-name-data my-2">
            <h6>
              <strong className="">Full Name:</strong>
            </h6>
            <ul className="list-unstyled ps-0 mb-0">
              <li className="d-flex align-items-center gap-10">
                <div className="left d-flex align-items-center gap-10">
                  <strong className="pe-2">Visible</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "full_name_visible")
                    }
                    checked={state.full_name_visible}
                  />
                </div>
                <div className="right d-flex align-items-center gap-10">
                  <strong className="pe-2">Required</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "full_name_required")
                    }
                    checked={state.full_name_required}
                  />
                </div>
              </li>
            </ul>
          </Col>
          <Col md={6} className="left-name-data my-2">
            <h6>
              <strong className="">Address:</strong>
            </h6>
            <ul className="list-unstyled ps-0 mb-0">
              <li className="d-flex align-items-center  gap-10">
                <div className="left d-flex align-items-center gap-10">
                  <strong className="pe-2">Visible</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) => handleToggle(event, "address_visible")}
                    checked={state.address_visible}
                  />
                </div>
                <div className="right d-flex align-items-center gap-10">
                  <strong className="pe-2">Required</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "address_required")
                    }
                    checked={state.address_required}
                  />
                </div>
              </li>
            </ul>
          </Col>
          <Col md={6} className="left-name-data my-2">
            <h6>
              <strong className="">Cell Phone:</strong>
            </h6>
            <ul className="list-unstyled ps-0 mb-0">
              <li className="d-flex align-items-center  gap-10">
                <div className="left d-flex align-items-center gap-10">
                  <strong className="pe-2">Visible</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "cell_phone_visible")
                    }
                    checked={state.cell_phone_visible}
                  />
                </div>
                <div className="right d-flex align-items-center gap-10">
                  <strong className="pe-2">Required</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) =>
                      handleToggle(event, "cell_phone_required")
                    }
                    checked={state.cell_phone_required}
                  />
                </div>
              </li>
            </ul>
          </Col>
          <Col md={6} className="left-name-data my-2">
            <h6>
              <strong className="">Email:</strong>
            </h6>
            <ul className="list-unstyled ps-0 mb-0">
              <li className="d-flex align-items-center  gap-10">
                <div className="left d-flex align-items-center gap-10">
                  <strong className="pe-2">Visible</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) => handleToggle(event, "email_visible")}
                    checked={state.email_visible}
                  />
                </div>
                <div className="right d-flex align-items-center gap-10">
                  <strong className="pe-2">Required</strong>
                  <Switch
                    offColor="#888"
                    onColor="#3363df"
                    onChange={(event) => handleToggle(event, "email_required")}
                    checked={state.email_required}
                  />
                </div>
              </li>
            </ul>
          </Col>

          {extraField &&
            extraField.length > 0 &&
            extraField.map((item, idx) => {
              return (
                <Col md={6} className="left-name-data my-2" key={idx}>
                  <h6>
                    <strong className="text-capitalize">{item.title}:</strong>
                  </h6>
                  <ul className="list-unstyled ps-0 mb-0">
                    <li className="d-flex align-items-center  gap-10">
                      <div className="left d-flex align-items-center gap-10">
                        <strong className="pe-2">Visible</strong>
                        <Switch
                          offColor="#888"
                          onColor="#3363df"
                          onChange={(event) =>
                            handleToggle(
                              event,
                              item.title.toLowerCase().split(" ").join("_") +
                                "_visible"
                            )
                          }
                          checked={
                            state[
                              item.title.toLowerCase().split(" ").join("_") +
                                "_visible"
                            ]
                          }
                        />
                      </div>
                      <div className="right d-flex align-items-center gap-10">
                        <strong className="pe-2">Required</strong>
                        <Switch
                          offColor="#888"
                          onColor="#3363df"
                          onChange={(event) =>
                            handleToggle(
                              event,
                              item.title.toLowerCase().split(" ").join("_") +
                                "_required"
                            )
                          }
                          checked={
                            state[
                              item.title.toLowerCase().split(" ").join("_") +
                                "_required"
                            ]
                          }
                        />
                      </div>
                    </li>
                  </ul>
                </Col>
              );
            })}
        </Row>
      </section>
      <div className="heading-fields-type">
        <h2>Add More Fields in Finance form.</h2>
        <Addons
          handleChange={handleExtraChange}
          data={extraField}
          handleSaveField={handleSaveField}
          activeTab={activeTab}
        />
      </div>
    </div>
  );
};

export default LeagalInfo;
